import { render, staticRenderFns } from "./importSupplierItem.vue?vue&type=template&id=eb8ab966&scoped=true"
import script from "./importSupplierItem.vue?vue&type=script&lang=js"
export * from "./importSupplierItem.vue?vue&type=script&lang=js"
import style0 from "./importSupplierItem.vue?vue&type=style&index=0&id=eb8ab966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8ab966",
  null
  
)

export default component.exports